import { selectLogo } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';


export const testId = 'partner-logo';
export function PartnerLogo(): JSX.Element {
    const logo = useAppSelector(selectLogo);

    return (
        <img
            data-testid={testId}
            style={{
                maxWidth: '250px',
                height: '100%',
                maxHeight: '40px',
                padding: '1px 0',
            }}
            src={logo}
            alt='logo'
            className={`object-contain h-full ${
                logo === 'drive.svg' && 'h-1/2'
            }`}
        />
    );
}
